<script>
import Piebk from "../components/graph/PieCumulBk.svelte";
 </script>
<h3>Page Test</h3>
  <div class="chart-wrapper">
    <Piebk />
  </div>
